module.exports = __webpack_public_path__ + "static/media/north-hills-estates.40695de0.pdf";